module.exports = __webpack_public_path__ + "img/Métrro.4adcec64.svg";